import { mdiAccountGroup } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "customers",
  title: "Ansprechpartner",
  tooltip: "Ansprechpartner, ihre Kontaktdaten und ihre Zuordnung zu Liegenschaften verwalten.",
  icon: mdiAccountGroup,
  routeSegment: "customers",
  getPages: (context) => [
    {
      id: "customers",
      title: "Ansprechpartner",
      path: "",
    },
  ],
}
